// extracted by mini-css-extract-plugin
export default {"row":"BriefInfo_row__GSR8p"};